import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';

// Components
import Button from 'components/atoms/Button';

// Constants
import { VEHICLE_ROUTE } from 'constants/routes';
import { APP_FLOW } from 'constants/appFlow';
import { NAVIGATION } from 'constants/navigations';

import './StartScreenOptions.scss';

const { IM_NEW_HERE, QUICK_APPT } = APP_FLOW;
const { FORWARD } = NAVIGATION;

const ns = 'start-screen-options';

const StartScreenOptions = ({
  goTo,
  setAppFlow,
  gtmUserEvent,
  gtmStartGenericEvent,
  intl,
  isQuickApptEnabled,
  setLocalizedQuickApptService
}) => {
  // @TODO: Investigate a way to use intl directly on redux to avoid using it here
  if (isQuickApptEnabled) {
    const tellusMoreText = intl.formatMessage({
      id: 'c8.quick.appointment.default.service.note',
      defaultMessage:
        'System Message: This appointment was set directly bypassing service and package selection. Please discuss service and/or repair needs.'
    });
    setLocalizedQuickApptService(tellusMoreText);
  }

  // TODO: Alert Validation
  return (
    <div className={`${ns}`}>
      <Container
        className={isQuickApptEnabled ? `${ns}--quick-appt-display` : ''}
      >
        <Row>
          <Col className={`${ns}__new_customer`}>
            <div className="start-screen-options__label">
              {intl.formatMessage({
                id: 'c8.start.page.new.customer'
              })}
            </div>
            <div className="start-screen-options__button">
              <Button
                onClick={() => {
                  gtmStartGenericEvent();
                  gtmUserEvent(
                    'Make - Year - Model Button',
                    'Clicked',
                    'Make - Year - Model selected',
                    'GTM_CURRENT_PAGE > New Customer Section'
                  );
                  setAppFlow(IM_NEW_HERE);
                  goTo(VEHICLE_ROUTE, FORWARD);
                }}
                buttonTheme="action"
                id="new_customer_button"
                tabIndex={0}
                aria-label={intl.formatMessage({
                  id: 'c8.aria.select.year.make.model',
                  defaultMessage: 'Select year, make, and model'
                })}
              >
                {intl.formatMessage({
                  id: 'c8.start.page.make.year.model'
                })}
              </Button>
            </div>
          </Col>
          {isQuickApptEnabled && (
            <Col className="start-screen-options__quick_appointment">
              <div className="start-screen-options__label">
                {intl.formatMessage({
                  id: 'c8.start.page.need.appointment.fast',
                  defaultMessage: 'Need an appointment fast?'
                })}
              </div>
              <div className="start-screen-options__button">
                <Button
                  onClick={() => {
                    gtmUserEvent(
                      'Quick appointment Button',
                      'Clicked',
                      'Schedule next available appointment selected',
                      'GTM_CURRENT_PAGE > New Customer Section'
                    );
                    setAppFlow(QUICK_APPT);
                    goTo(VEHICLE_ROUTE, FORWARD);
                    gtmStartGenericEvent();
                  }}
                  buttonTheme="action"
                  id="quick_appointment_button"
                  tabIndex={0}
                  aria-label={intl.formatMessage({
                    id: 'c8.aria.quick.appointment',
                    defaultMessage: 'Schedule next available appointment'
                  })}
                >
                  {intl.formatMessage({
                    id: 'c8.start.page.schedule.next.appointment',
                    defaultMessage: 'Schedule next available appointment'
                  })}
                </Button>
              </div>
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
};

StartScreenOptions.propTypes = {
  goTo: PropTypes.func.isRequired,
  gtmStartGenericEvent: PropTypes.func.isRequired,
  gtmUserEvent: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  setAppFlow: PropTypes.func.isRequired,
  setLocalizedQuickApptService: PropTypes.func.isRequired,
  isQuickApptEnabled: PropTypes.bool
};

export default StartScreenOptions;



// WEBPACK FOOTER //
// ./src/components/molecules/StartScreenOptions/StartScreenOptions.js